import { EnergySource } from "./energy-source"

export class BuyingType {
    public type: string // random, explicit, or other
    public types?: EnergySource[]
    constructor(type: string, types?: EnergySource[]) {
        this.type = type
        this.types = types
    }
}
